export default function Compas() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
      <mask
        id='mask0_6217_47920'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_6217_47920)'>
        <path
          d='M4.5 13.3828V11.8828H19.5V13.3828H4.5ZM4.5 10.4983V8.99831H19.5V10.4983H4.5ZM11.25 21.4983V17.8368L9.4 19.6868L8.34625 18.6328L12 14.9791L15.6538 18.6328L14.6 19.6868L12.75 17.8676V21.4983H11.25ZM12 7.40206L8.34625 3.74831L9.4 2.69456L11.25 4.54456V0.882812H12.75V4.54456L14.6 2.69456L15.6538 3.74831L12 7.40206Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
